module.exports = __webpack_public_path__ + "static/background-9bb738c80f444647c186b83fe1dffd2f.jpg";